import { AllNamedConfigTypeCases } from 'components/consumer-page-widgets/WidgetTypeSelect';
import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { FormSelectField, FormTextField } from 'ui';
import { FormikErrors } from 'formik';
import { consumer } from '@tock/coretypes';
import { requireFields } from '@tock/shared/utils/FormValidators';

export const validLayoutWidgetItemTypes: AllNamedConfigTypeCases[] = [
  'cardLinkWidgetConfig',
  'avatarCardLinkWidgetConfig',
];

export interface RowLayoutWidgetFields extends BaseWidgetFormFields {
  namedConfigurationIdLeft?: number;
  widthPercentageLeft: number;
  namedConfigurationIdRight?: number;
  widthPercentageRight: number;
}

interface RowLayoutWidgetFieldsProps {
  namedConfigurations: consumer.NamedConfiguration[];
}

export function validateRowLayoutWidgetFormFields(values: RowLayoutWidgetFields) {
  const errors: FormikErrors<RowLayoutWidgetFields> = requireFields(
    values,
    'namedConfigurationIdLeft',
    'namedConfigurationIdRight'
  );

  const widthErrorMessage = 'Width percentages must sum to 100';

  if (Number(values.widthPercentageLeft) + Number(values.widthPercentageRight) !== 100) {
    errors.widthPercentageLeft = widthErrorMessage;
    errors.widthPercentageRight = widthErrorMessage;
  }

  return errors;
}

export const RowLayoutWidgetFormFields: React.FunctionComponent<
  React.PropsWithChildren<RowLayoutWidgetFieldsProps>
> = ({ namedConfigurations }) => {
  const namedConfigurationOptions = namedConfigurations.map(
    ({ id, name, namedConfigurationConfig }) => {
      return <option key={id} label={`${name}`} value={id} />;
    }
  );

  return (
    <>
      <FormSelectField
        id="namedConfigurationIdLeft"
        name="namedConfigurationIdLeft"
        label="Left content"
        fullWidth
        InputLabelProps={{ shrink: true }}
      >
        {namedConfigurationOptions}
      </FormSelectField>
      <FormTextField
        type="number"
        id="widthPercentageLeft"
        name="widthPercentageLeft"
        label="Left item percentage width"
        helperText="(e.g., '57' = 57%)"
        fullWidth
      />
      <FormSelectField
        id="namedConfigurationIdRight"
        name="namedConfigurationIdRight"
        label="Right content"
        fullWidth
        InputLabelProps={{ shrink: true }}
      >
        {namedConfigurationOptions}
      </FormSelectField>
      <FormTextField
        type="number"
        id="widthPercentageRight"
        name="widthPercentageRight"
        label="Right item percentage width"
        helperText="(e.g., '57' = 57%)"
        fullWidth
      />
    </>
  );
};
